export enum BookingError {
  BAD_USER_INPUT = 'BAD_USER_INPUT',
  CREATE_BOOKING_ERROR = 'CREATE_BOOKING_ERROR',
  EMAIL_VALIDATION = 'EMAIL_VALIDATION',
  ERR_BOOKING_ALREADY_CANCELLED = 'ERR_BOOKING_ALREADY_CANCELLED',
  ERR_BOOKING_AUTHORIZATION = 'ERR_BOOKING_AUTHORIZATION',
  ERR_BOOKING_NOT_FOUND = 'ERR_BOOKING_NOT_FOUND',
  ERR_BOOKING_NOT_OWNED = 'ERR_BOOKING_NOT_OWNED',
  ERR_CANCELATION_NOT_ALLOWED = 'ERR_CANCELATION_NOT_ALLOWED',
  ERR_CANCELLATION_FAILED = 'ERR_CANCELLATION_FAILED',
  ERR_CANCELLATION_FAILED_WITH_SUCCESS = 'ERR_CANCELLATION_FAILED_WITH_SUCCESS',
  ERR_MEMBERSHIP_ALREADY_CONNECTED = 'ERR_MEMBERSHIP_ALREADY_CONNECTED',
  ERR_SOMETHING_WENT_WRONG = 'ERR_SOMETHING_WENT_WRONG',
  ERR_TOKEN_INVALID_OR_EXPIRED = 'ERR_TOKEN_INVALID_OR_EXPIRED',
  GENERIC_ERROR = 'GENERIC_ERROR',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  JWT_DECODE_ERROR = 'JWT_DECODE_ERROR',
  JWT_VALIDATION_ERROR = 'JWT_VALIDATION_ERROR',
  MISSING_REQUIRED_PARAMS_ERROR = 'MISSING_REQUIRED_PARAMS_ERROR',
  MISSING_WINDOW_OBJECT = 'MISSING_WINDOW_OBJECT',
  NO_PRODUCTS_ERROR = 'NO_PRODUCTS_ERROR',
  PAYLOAD_VALIDATION = 'PAYLOAD_VALIDATION',
  UNABLE_TO_GET_PAYMENT_LINK = 'UNABLE_TO_GET_PAYMENT_LINK',
  UNABLE_TO_RETRIEVE_JWT_OR_LOUNGE = 'UNABLE_TO_RETRIEVE_JWT_OR_LOUNGE',
  UNABLE_TO_RETRIEVE_PARAMS = 'UNABLE_TO_RETRIEVE_PARAMS',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  UNNABLE_TO_COMPLETE_PAYMENT = 'UNNABLE_TO_COMPLETE_PAYMENT',
  WRONG_BOOKING_MODE = 'WRONG_BOOKING_MODE',
}

export enum BookingWarn {
  CONSUMER_IS_NOT_VALID = 'CONSUMER_IS_NOT_VALID',
  MISSED_TRANSLATION_KEYS = 'MISSED_TRANSLATION_KEYS',
  MISSING_LINKED_ACCOUNT = 'MISSING_LINKED_ACCOUNT',
  NO_MOBILE_ENV = 'NO_MOBILE_ENV',
  SESSION_STORAGE_GET = 'SESSION_STORAGE_GET',
  SESSION_STORAGE_REMOVE = 'SESSION_STORAGE_REMOVE',
  SESSION_STORAGE_SET = 'SESSION_STORAGE_SET',
  TEST = 'TEST',
  THEME_WAS_NOT_FOUND = 'THEME_WAS_NOT_FOUND',
}

export enum BookingInfo {
  CONSUMER_ID = 'CONSUMER_ID',
  CONSUMER_RESPONSE = 'CONSUMER_RESPONSE',
  CREATE_PDF_FAILED = 'CREATE_PDF_FAILED',
  PARAM_FOUND = 'PARAM_FOUND',
  URL_CHANGE = 'URL_CHANGE',
}

export enum ANALYTICS_TAGS {
  ON_CHANGE_DATE = 'CG_Flight_Date_Chk_Avl',
  ON_CHANGE_DATE_EDIT = 'CG_Flight_Date_Chk_Avl_Amnd',
  ON_CHANGE_DATE_ERROR = 'ERR_Flight_Date_Chk_Avl',
  ON_CHANGE_DATE_ERROR_EDIT = 'ERR_Flight_Date_Chk_Avl_Amnd',
  ON_CHANGE_EMAIL_ADDRESS = 'CHG_Email_Address',
  ON_CHANGE_ERROR_ATTENDEES_AVL = 'ERR_Number_Chk_Avl',
  ON_CHANGE_ERROR_ATTENDEES_AVL_EDIT = 'ERR_Number_Chk_Avl_Amnd',
  ON_CHANGE_FLIGHT_NUMBER = 'CG_Flight_Number_Chk_Avl',
  ON_CHANGE_FLIGHT_NUMBER_EDIT = 'CG_Flight_Number_Chk_Avl_Amnd',
  ON_CHANGE_FLIGHT_NUMBER_ERROR = 'ERR_Flight_Number_Chk_Avl',
  ON_CHANGE_FLIGHT_NUMBER_ERROR_EDIT = 'ERR_Flight_Number_Chk_Avl_Amnd',
  ON_CHECK_CODE_CHANGE = 'CG_Email_Code',
  ON_CHECK_CODE_ENTER = 'On_PG_Email_Code',
  ON_CHECK_CODE_VERIFY = 'Ck_BTN_Verify_Email_Code',
  ON_CONFIRM_AMEND_PG = 'On_PG_Sv_Chng_Amnd',
  ON_CONFIRM_AMEND_SAVE = 'CK_BTN_Sv_Chng_Amnd',
  ON_CONFIRMED_BTN_DECLINE = 'On_PG_Amnd_Dclnd',
  ON_CONFIRMED_BTN_DOWNLOAD_AMEND = 'CK_BTN__Amnd_Cfnd',
  ON_CONTINUE_BUTTON_AVI = 'CK_BTN_Chk_Avl',
  ON_CONTINUE_BUTTON_AVI_EDIT = 'CK_BTN_Chk_Avl_Amnd',
  ON_CONTINUE_CLICK = 'CK_BTN_Continue',
  ON_HIT_BACK_BUTTON = 'CK_BTN_Back_',
  ON_INDICATOR_LOADED_OFF = 'On_Bsns_Indicator_OFF',
  ON_INDICATOR_LOADED_ON = 'On_Bsns_Indicator_ON',
  ON_INDICATOR_REACHED_WITH_SCROLL = 'On_Bsns_Indicator_Scrolled',
  ON_INDICATOR_SELECTED_LEVEL = 'CK_Pick_Slot_Bsns_Indicator',
  ON_PAGE_CONFIRMED_BACK_BTN = 'Ck_BTN_Back_Bk_Cfnd',
  ON_PAGE_CONFIRMED_BTN_DOWNLOAD = 'CK_BTN__Bk_Cfnd',
  ON_PAGE_CONFIRMED_BTN_RFUND_DOWNLOAD = 'CK_BTN__Amnd_Cfnd_Rfnd',
  ON_PAGE_ENTER_CHECKAVAILABILITY = 'On_PG_Chk_Avl',
  ON_PAGE_ENTER_CHECKAVAILABILITY_EDIT = 'On_PG_Chk_Avl_Amnd',
  ON_PAGE_ENTER_CONFIRMED = 'On_PG_Bk_Cfnd',
  ON_PAGE_ENTER_CONFIRMED_AMEND = 'On_PG_Amnd_Cfnd',
  ON_PAGE_ENTER_EMAIL = 'On_PG_Enter_Email',
  ON_PAYMENT_CONTINUE = 'CK_BTN_Confirm_G_T_Pmt',
  ON_PAYMENT_ENTER = 'On_PG_G_T_Pmt',
  ON_PAYMENT_PROCESSED = 'On_PG_Processing_Pmt',
  ON_REFUND_AMENDMENT_ENTER = 'On_PG_Amnd_Cfnd_Rfnd',
  ON_REFUND_FAILED_AMEND = 'CK_BTN__Amnd_Cfnd_Rfnd_Err',
  ON_SIGNUP_PAGE_CONCENT = 'Tick_Consent_Upd_Dtl',
  ON_SIGNUP_PAGE_CONFIRM = 'CK_BTN_Confirm_Upd_Dtl',
  ON_SIGNUP_PAGE_ENTER = 'On_PG_Upd_Dtl',
  ON_SIGNUP_PAGE_FIRSTNAME_UPDATE = 'CG_First_Name_Upd_Dtl',
  ON_SIGNUP_PAGE_LASTNAME_UPDATE = 'CG_Last_Name_Upd_Dtl',
  ON_SLOT_AMEND_CONFIRMED = 'CK_BTN_Confirm_Pick_Slot_Amnd',
  ON_SLOT_AMEND_ENTER = 'On_PG_Pick_Slot_Amnd',
  ON_SLOT_CHANGE = 'CK_Time_Slot_Pick_Slot ',
  ON_SLOT_CHANGED_AMEND = 'CK_Time_Slot_Pick_Slot_Amnd',
  ON_SLOT_CONTINUE = 'CK_BTN_Confirm_Pick_Slot',
  ON_SLOT_MISSED = 'On_PG_Slot_Mis',
  ON_SLOT_PG_ENTER = 'On_PG_Pick_Slot',
  ON_SLOT_SELECT_ANOTHER = 'CK_BTN_Sel_Slot_Mis',
  ON_SLOT_SELECT_GO_TO_LOUNGE = 'CK_BTN_GO_Slot_Mis',
  ON_TOOLTIP_SELECTED = 'CK_Question_Mark_Bsns_In',
}

export const DATADOG_ERROR_LOGS = {
  [BookingError.BAD_USER_INPUT]: BookingError.BAD_USER_INPUT,
  [BookingError.CREATE_BOOKING_ERROR]:
    'There was an error during create booking',
  [BookingError.EMAIL_VALIDATION]:
    'An error occured while validating email address',
  [BookingError.ERR_BOOKING_ALREADY_CANCELLED]:
    BookingError.ERR_BOOKING_ALREADY_CANCELLED,
  [BookingError.ERR_BOOKING_AUTHORIZATION]:
    BookingError.ERR_BOOKING_AUTHORIZATION,
  [BookingError.ERR_BOOKING_NOT_FOUND]: BookingError.ERR_BOOKING_NOT_FOUND,
  [BookingError.ERR_BOOKING_NOT_OWNED]: BookingError.ERR_BOOKING_NOT_OWNED,
  [BookingError.ERR_CANCELATION_NOT_ALLOWED]:
    BookingError.ERR_CANCELATION_NOT_ALLOWED,
  [BookingError.ERR_CANCELLATION_FAILED]: BookingError.ERR_CANCELLATION_FAILED,
  [BookingError.ERR_CANCELLATION_FAILED_WITH_SUCCESS]:
    BookingError.ERR_CANCELLATION_FAILED_WITH_SUCCESS,
  [BookingError.ERR_MEMBERSHIP_ALREADY_CONNECTED]:
    BookingError.ERR_MEMBERSHIP_ALREADY_CONNECTED,
  [BookingError.ERR_SOMETHING_WENT_WRONG]:
    BookingError.ERR_SOMETHING_WENT_WRONG,
  [BookingError.ERR_TOKEN_INVALID_OR_EXPIRED]:
    BookingError.ERR_TOKEN_INVALID_OR_EXPIRED,
  [BookingError.GENERIC_ERROR]: 'There was an error during create booking',
  [BookingError.INTERNAL_SERVER_ERROR]: BookingError.INTERNAL_SERVER_ERROR,
  [BookingError.JWT_DECODE_ERROR]: BookingError.JWT_DECODE_ERROR,
  [BookingError.JWT_VALIDATION_ERROR]: BookingError.JWT_VALIDATION_ERROR,
  [BookingError.MISSING_REQUIRED_PARAMS_ERROR]: 'Missing required params',
  [BookingError.MISSING_WINDOW_OBJECT]: BookingError.MISSING_WINDOW_OBJECT,
  [BookingError.NO_PRODUCTS_ERROR]: 'No products found',
  [BookingError.PAYLOAD_VALIDATION]: 'Payload validation failed',
  [BookingError.UNABLE_TO_GET_PAYMENT_LINK]:
    BookingError.UNABLE_TO_GET_PAYMENT_LINK,
  [BookingError.UNABLE_TO_RETRIEVE_JWT_OR_LOUNGE]:
    'Unable to retrieve jwt token or lounge code from both query and storage',
  [BookingError.UNABLE_TO_RETRIEVE_PARAMS]:
    'Unable to retrieve params from both query and storage',
  [BookingError.UNEXPECTED_ERROR]: BookingError.UNEXPECTED_ERROR,
  [BookingError.UNNABLE_TO_COMPLETE_PAYMENT]:
    BookingError.UNNABLE_TO_COMPLETE_PAYMENT,
  [BookingError.WRONG_BOOKING_MODE]:
    'Must use CREATE booking mode to create a booking',
};

export const DATADOG_WARN_LOGS = {
  [BookingWarn.CONSUMER_IS_NOT_VALID]: BookingWarn.CONSUMER_IS_NOT_VALID,
  [BookingWarn.MISSED_TRANSLATION_KEYS]:
    'There are missing keys in the translation object',
  [BookingWarn.MISSING_LINKED_ACCOUNT]:
    'Linked account was not found during create booking',
  [BookingWarn.NO_MOBILE_ENV]: 'Unable to detect mobile environment',
  [BookingWarn.SESSION_STORAGE_GET]: 'Failed to GET item from session storage',
  [BookingWarn.SESSION_STORAGE_REMOVE]:
    'Failed to REMOVE item from session storage',
  [BookingWarn.SESSION_STORAGE_SET]: 'Failed to SET item to session storage',
  [BookingWarn.TEST]: 'TEST',
  [BookingWarn.THEME_WAS_NOT_FOUND]:
    'The theme was not found and the default theme was loaded',
};

export const DATADOG_INFO_LOGS = {
  [BookingInfo.CONSUMER_ID]: 'Successfully retrieved consumer id',
  [BookingInfo.CONSUMER_RESPONSE]: BookingInfo.CONSUMER_RESPONSE,
  [BookingInfo.CREATE_PDF_FAILED]: 'Create Webview PDF Data URI Failed',
  [BookingInfo.PARAM_FOUND]: 'Successfully retrieved url params',
  [BookingInfo.URL_CHANGE]: 'url change',
};

export enum PAGENAMES {
  BOOKING_AMEND = 'Chk_Avl_Amnd',
  BOOKING_CONFIRMED = 'BookingConfirmed',
  CONFIRM_AMEND = 'Sv_Chng_Amnd',
  CONFIRM_CREATE = 'G_T_Pmt',
  EMAIL_CODE = 'Email_Code',
  ENTER_EMAIL = 'Enter_Email',
  FAILURE_AMEND_REFUND = 'Refund_fail',
  FAULURE_BOOKING = 'Slot_Mis',
  INDEX = 'Chk_Avl',
  LOGIN = 'login',
  PICK_SLOT = 'Pick_Slot',
  SIGNUP = 'Upd_Dtl',
  SLOTAMEND = 'Slot_Amnd',
  TEST_PAGENAME = 'TEST_PAGENAME',
}
